import axios from "axios";

const getData = async (endpoint)=>{
    try {
      const response = await axios.get('https://dynamic-resume-ryqd.onrender.com/' + endpoint.endpoint)   
      console.log(response.data)
      return response.data;
    } catch (error) {
      console.log(error)  
    }
}

export default getData;